import React from 'react'

import './BrowserWindow.css'

const BrowserWindow = ({
  subject,
  text,
  image,
  isMobile
}) => {
  const browser = isMobile ? 'browser browser--mobile' : 'browser';
  return (
    <div className={browser}>
      { subject && <div className="browser__title">{ subject }</div> }
      { text && <div className="browser__content">{ text }</div> }
      { image && <img src={image} alt="" className="browser__img"/> }
    </div>
  )
}

export default BrowserWindow


// WEBPACK FOOTER //
// ./src/components/campaigns/previews/BrowserWindow.js